export default __webpack_public_path__ + "static/media/Blog8.fff555f5.png";